module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-ccb514.dfe6b35b.png";